import { useEffect } from 'react';

import { useAtom, useAtomValue } from 'jotai';

import { socialProfileAtom } from '@/components/pages/giveaway-picker/Atoms/socialProfileAtom';
// Atoms
import { currentStepAtom } from '@/components/pages/giveaway-picker/Atoms/stepsAtoms';
//Components
import { DrawSummary } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/DrawSummary';
import { GiveawayPickerBanner } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/GiveawayPickerBanner';
import { NavigationButtons } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/Navigation';
import { StepsWrapper } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/components/StepsWrapper';

type StepSelectorProps = {
    children: React.ReactNode;
};

export function GiveawayPickerWrapper({ children }: StepSelectorProps) {
    const socialProfile = useAtomValue(socialProfileAtom);
    const [currentStep, setCurrentStep] = useAtom(currentStepAtom);

    const isLastStep = currentStep === 4;

    useEffect(() => {
        if (!socialProfile) {
            setCurrentStep(1);
        }
    }, [socialProfile, setCurrentStep]);

    return (
        <div className="flex w-full flex-col gap-12 lg:gap-20">
            <StepsWrapper />
            <div className="flex h-fit flex-col items-start justify-between gap-12 lg:h-full lg:flex-row xl:gap-24">
                <div className="lg:gap-O flex h-fit w-full flex-1 flex-col gap-5 lg:h-full lg:w-fit lg:justify-between">
                    {children}
                    {!isLastStep ? <NavigationButtons /> : null}
                </div>
                {!isLastStep ? (
                    <div className="w-full space-y-4 lg:w-fit">
                        <GiveawayPickerBanner />
                        <DrawSummary />
                    </div>
                ) : null}
            </div>
        </div>
    );
}
